import classNames from 'classnames'

const ButtonMinus = ({ disabled, handleMinus }) => {
  return (
    <div className={classNames('counter_btn_wrapper', { disabled })} onClick={handleMinus}>
      <svg
        className="counter_btn btn_minus"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="2"
        viewBox="0 0 12 2"
        fill="none"
      >
        <path d="M1 1H11" stroke="#29293D" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  )
}

export default ButtonMinus
